require('../../modules/es.math.log2');
var path = require('../../internals/path');

module.exports = path.Math.log2;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/math/log2.js
// module id = 1217
// module chunks = 1